module.exports = __webpack_public_path__ + "img/tripadvisor.8ee01200.svg";